import React from 'react';

import SplitTestContext from './SplitTestContext';

function Variant({ children, name }) {
    return (
        <SplitTestContext.Consumer>
            {({ calculateProps, testName, experimentGroup }) => {
                if (name !== experimentGroup) {
                    return null;
                }

                return React.Children.map(
                    children,
                    (child) => typeof child === 'function'
                        ? React.cloneElement(child, {
                            ...child.props,
                            ...calculateProps(testName, experimentGroup),
                        })
                        : child,
                );
            }}
        </SplitTestContext.Consumer>
    );
}

export default Variant;
